import { useEffect, useState } from 'react';

import { useAuth } from '@opendoor/auth-fe/context';
import { useFeatureFlagEvaluator } from 'components/helpers/hooks';

// The BFF serializes a GrowthBook boolean as 'true'; the localStorage QA
// override normalizes to 'on' (see getLocalFeatureFlagOverrides).
const flagIsOn = (variant: string) => variant === 'true' || variant === 'on';

export const AVAILABLE_SOON_SEGMENT_FLAG = 'growth-26-09-available-soon';

/**
 * Whether the For sale / Available soon inventory segment control renders.
 * Defaults to false until the GrowthBook read resolves; QA overrides via
 * localStorage `opendoor.cosmos.<flag>` (see getLocalFeatureFlagOverrides).
 */
export const useAvailableSoonSegmentEnabled = (): boolean => {
  const { user } = useAuth();
  const evaluate = useFeatureFlagEvaluator(user?.customerUuid ?? '', flagIsOn);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    evaluate(AVAILABLE_SOON_SEGMENT_FLAG)
      .then((on) => {
        if (!cancelled) {
          setEnabled(on);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [evaluate]);

  return enabled;
};
